<app-public-page-template [cardSize]="CARDSIZE.LG" [headerText]="'Frequently Asked Questions'" [showHeaderRule]="false">
  <p-accordion [value]="0" [multiple]="true">
    @for (faq of faqs; track faq; let i = $index) {
      <p-accordion-panel [value]="i">
        <p-accordion-header>
          {{ faq.sectionName }}
        </p-accordion-header>
        <p-accordion-content>
          @for (qa of faq.faqs; track qa) {
            <h3>{{ qa.question }}</h3>
            <p [innerHTML]="qa.answer"></p>
          }
        </p-accordion-content>
      </p-accordion-panel>
    }
  </p-accordion>
</app-public-page-template>